import { put, takeEvery } from 'redux-saga/effects';
import { addItem as notify } from '../notifications/actions';
import apiErrorMessage from '../../utils/Api/apiErrorMessage';


function* handleError({ payload: { response, apiErrors } = {} }) {
  if (!response) return;

  // CREW-1283 — `apiErrors` is a JSON:API array for most endpoints now, which
  // has no `error` key; apiErrorMessage reads both that and the legacy object.
  const text = apiErrorMessage({ apiErrors, message: response.statusText }, response.statusText);
  const errorMessage = text.split(/,|\n/).map((e) => <div key={e}>{e}</div>);

  if (response.status === 500) {
    yield put(notify({
      type: 'error',
      title: '500 Server Error',
      message: errorMessage,
    }));
  }

  if (response.status === 400) {
    yield put(notify({
      type: 'error',
      title: '400 Server Error',
      message: errorMessage,
    }));
  }
}

export default function getFeatureSagas() {
  return [
    takeEvery((action) => action.error, handleError),
  ];
}
